import { render, staticRenderFns } from "./StyleDialogLabelsTab.vue?vue&type=template&id=0ecaf883&scoped=true&"
import script from "./StyleDialogLabelsTab.vue?vue&type=script&lang=js&"
export * from "./StyleDialogLabelsTab.vue?vue&type=script&lang=js&"
import style0 from "./StyleDialogLabelsTab.vue?vue&type=style&index=0&id=0ecaf883&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecaf883",
  null
  
)

export default component.exports